import React, { useContext } from "react";
import { FormControlLabel, Checkbox, Tooltip } from "@mui/material";
import { LoadingContext } from "../M_Utils";
import PropTypes from "prop-types";

export function MCheckBox({
  label,
  checked,
  icon,
  checkedIcon,
  onChange,
  disabled,
  color,
  fontSize,
  required,
  labelColor,
  tooltipName,
  noPadding,
}) {
  const ctx = useContext(LoadingContext);

  color = color || ctx.primaryColor || "var(--color-black)";
  labelColor = labelColor || ctx.secondaryColor || "var(--color-black)";

  const handleKeyPressEvent = (event) => {
    if (event.key === "Enter") {
      handleChange({ target: { checked: !checked } });
    }
  };

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Tooltip title={tooltipName || ""}>
      <FormControlLabel
        sx={{
          margin: !label ? "0px" : "5px 0px",
          color: labelColor,
          "& .MuiSvgIcon-root": { fontSize: fontSize },
        }}
        label={label}
        control={
          <Checkbox
            checked={checked}
            sx={{
              color: color,

              "&.Mui-checked": {
                color: color,
              },

              "&.Mui-checked.Mui-disabled": {
                borderRadius: "1px",

                "& .MuiSvgIcon-root": {
                  color: "var(--color-grey)",
                },
              },

              "&.MuiCheckbox-root:hover": {
                backgroundColor: "transparent",
              },

              "& .MuiSvgIcon-root": { fontSize: fontSize },
              padding: noPadding ? "0px" : "9px",
            }}
            disabled={disabled}
            icon={icon}
            checkedIcon={checkedIcon}
            onChange={onChange}
          />
        }
      />
    </Tooltip>
  );
}
MCheckBox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  icon: PropTypes.element,
  checkedIcon: PropTypes.element,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  required: PropTypes.bool,
  labelColor: PropTypes.string,
  tooltipName: PropTypes.string,
  noPadding: PropTypes.bool,
};
